import TileArticlePlaceholder from './TileArticlePlaceholder'

export default TileArticlePlaceholder
// eslint-disable-next-line import/export
export * from './TileArticlePlaceholder'
